export enum NeverEverEligibilityStatus {
  UNKNOWN = "UNKNOWN",
  ELIGIBLE = "ELIGIBLE",
  INELIGIBLE = "INELIGIBLE",
  ELIGIBILITY_CHECK_ERROR = "ELIGIBILITY_CHECK_ERROR",
}

export const NeverEverEligibilityStatusDisplayNameMap = {
  [NeverEverEligibilityStatus.UNKNOWN]: "Unknown",
  [NeverEverEligibilityStatus.INELIGIBLE]: "Ineligible",
  [NeverEverEligibilityStatus.ELIGIBLE]: "Eligible",
  [NeverEverEligibilityStatus.ELIGIBILITY_CHECK_ERROR]: "Request failed",
};

export enum NeverEverAccreditationStatus {
  UNKNOWN = "UNKNOWN",
  ACCREDITED = "ACCREDITED",
  NOT_ACCREDITED = "NOT_ACCREDITED",
  ELIGIBILITY_CHECK_ERROR = "ELIGIBILITY_CHECK_ERROR",
}

export const NeverEverAccreditationStatusDisplayNameMap = {
  [NeverEverAccreditationStatus.UNKNOWN]: "Unknown",
  [NeverEverAccreditationStatus.ACCREDITED]: "Accredited",
  [NeverEverAccreditationStatus.NOT_ACCREDITED]: "Not Accredited",
  [NeverEverAccreditationStatus.ELIGIBILITY_CHECK_ERROR]:
    "Accreditation request failed",
};
